import { TimerStarIcon } from './TimerStarIcon';

/**
 * author: Colton Wiscombe
 * id EEC275B0-442C-4C00-A1AE-662EF4477A13
 * name timer-star
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-star.svg
 * tags
 * - Date / Time 
 */
export const StopwatchFavoriteIcon = TimerStarIcon;
export default StopwatchFavoriteIcon